/**
 * @generated SignedSource<<dffc500273d0ec0aa013a920e5e8e679>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type RequestTimeSelectionControl_TimeSlots$data = {
  readonly id: string;
  readonly timeSlots: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly availability: SlotAvailability;
        readonly id: string;
        readonly time: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "RequestTimeSelectionControl_TimeSlots";
};
export type RequestTimeSelectionControl_TimeSlots$key = {
  readonly " $data"?: RequestTimeSelectionControl_TimeSlots$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestTimeSelectionControl_TimeSlots">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestTimeSelectionControl_TimeSlots",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "TimeSlotConnection",
      "kind": "LinkedField",
      "name": "timeSlots",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlotEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TimeSlot",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "time",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "availability",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "timeSlots(first:1000)"
    }
  ],
  "type": "Agenda",
  "abstractKey": null
};
})();

(node as any).hash = "73f06d4b6dda89af5dd65770549370a2";

export default node;
